import { FlagIcon } from '@snapi/icons';
import { ReportSummary } from '@snapi/types';
import { ReportUtils } from '@snapi/utils';
import { DashboardCard } from '../dashboard-card';
import { useReportContext } from '../../report-context';
import { DevInfo } from '@snapi/luxury';
import { Description } from '@snapi/luxury';
import { NewDashboardCard } from '../new-dashboard-card';

const DiversityInfo = [
  {
    title: 'What is diversity?',
    description:
      'Diversity defines the trillions of bacteria that exist in the microbiome. The different communities of bacteria reflect how diverse it is.',
  },
  {
    title: 'Why is it important?',
    description:
      'Microbiome diversity is directly correlated with overall well-being and is key is measuring gut health.',
  },
  {
    title: 'What does my result mean?',
    description:
      'If you see a red tab, don’t be alarmed! Your diversity may be considered lower than average- but we’re here to improve that. If you see a green tab, that means things are looking good and diversity is on track!',
  },
];

const scoreToText = (score: number, baby: string) => {
  if (score < 15) {
    return `${baby}'s diversity could use some work.`;
  } else if (score < 85) {
    return `${baby}'s gut shows healthy diversity. Looking good!`;
  } else {
    return `${baby}’s gut is diverse.`;
  }
};

export const DiversityCard: React.FC<
  Omit<ReportSummary['diversity'], 'good'>
> = ({ score }) => {
  const { baby } = useReportContext();
  const good = ReportUtils.diversity.isGood(score);

  return (
    <NewDashboardCard
      badge={{ good, status: good ? 'Nice work' : 'Attention Needed' }}
      title="Diversity"
      summary={scoreToText(score, baby.name)}
      info={DiversityInfo}
    >
      <DevInfo>
        <span className="absolute top-[10px] left-[100px] font-mono font-bold">
          {score.toFixed(1)} %
        </span>
      </DevInfo>
      <div className="flex flex-col flex-1 justify-center lg:mt-9">
        <div className="flex pt-7 relative lg:mt-5 max-h-20 xl:w-[256px] xl:mx-auto">
          <div className="absolute top-0 left-0 bottom-0 right-0 flex">
            <div
              style={{ width: `${score}%` }}
              className="text-left flex justify-end"
            />
            <FlagIcon className="top-1 w-[28px] h-[48px] z-20" />
          </div>
          <div
            className="h-5 rounded-md flex flex-1 relative"
            style={{
              background: 'linear-gradient(90deg, #FFE69A 0%, #D3EDC8 72.56%)',
            }}
          />
          <div className="h-7 w-[1px] absolute bg-body top-[24px] left-[38px] md:left-[46px] lg:left-[31px] xl:left-[38px]"></div>
          <div className="h-7 w-[1px] absolute bg-body top-[24px] left-[218px] md:left-[265px] lg:left-[176px] xl:left-[218px]"></div>
        </div>
        <div className="flex mt-2 justify-between">
          <div className="flex">
            <Description>Low</Description>
          </div>
          <div className="flex">
            <Description>Normal</Description>
          </div>
          <div className="flex">
            <Description>High</Description>
          </div>
        </div>
      </div>
    </NewDashboardCard>
  );
};
